import { COUNTRY_CODES } from 'appconstants';

export default countryId => {
  const country = COUNTRY_CODES.find(value => value.ID === countryId);
  return country && country.ALPHA2;
};
